export const amenitiesMapData = {
  t1: {
    id: 't1',
    title: 'Tiện ích tầng 1',
    tab: '1st_floor',
    img: '/assets/images/amenity-layouts/T1_facilities.webp',
    amenities: [
      {
        id: '1',
        name: 'main_entrance',
        img: '/assets/images/amenity-layouts/images/Congchinh.webp',
        coordinates: { x: 2, y: 65 },
      },

      {
        id: '2',
        name: 'security_post',
        img: '/assets/images/amenity-layouts/images/Chotanninh.jpg',
        coordinates: { x: 2, y: 80 },
      },
      {
        id: '3',
        name: 'alternate_entrance',
        coordinates: { x: 2, y: 50 },
      },
      {
        id: '4',
        name: 'basement_entrance',
        coordinates: { x: 53, y: 44.91 },
      },
      {
        id: '5',
        name: 'art_decoration',
        coordinates: { x: 60, y: 39.62 },
      },
      {
        id: '6',
        name: 'pick_up_point',
        img: '/assets/images/amenity-layouts/images/Dropoff.jpg',
        coordinates: { x: 15, y: 75 },
      },
      {
        id: '7',
        name: 'thinhvuong_roundabout',
        img: '/assets/images/amenity-layouts/images/Vongxoaythinhvuong.jpg',
        coordinates: { x: 65, y: 73 },
      },
      {
        id: '8',
        name: 'pet_corner',
        coordinates: { x: 90, y: 71.32 },
      },
      {
        id: '9',
        name: 'delivery_point',
        coordinates: { x: 85, y: 71.32 },
      },
      {
        id: '10',
        name: 'sculpture_garden',
        coordinates: { x: 30, y: 75 },
      },
      {
        id: '11',
        name: 'zen_corner',
        coordinates: { x: 53, y: 80 },
      },
      {
        id: '12',
        name: 'green_wall',
        coordinates: { x: 95, y: 55 },
      },
      {
        id: '13',
        name: 'playground',
        img: '/assets/images/amenity-layouts/images/Sanchoivandong.jpg',
        coordinates: { x: 95, y: 30 },
      },
      {
        id: '14',
        name: 'walking_path',
        img: '/assets/images/amenity-layouts/images/Duongdaobo.webp',
        coordinates: { x: 20, y: 82 },
      },
      {
        id: '15',
        name: 'apartment_entrance',
        coordinates: { x: 67.5, y: 60.75 },
      },
      {
        id: '16',
        name: 'officetel_entrance',
        coordinates: { x: 70, y: 50 },
      },
    ],
  },
  t5: {
    id: 't5',
    title: 'Tiện ích tầng 5',
    tab: '5th_floor',
    img: '/assets/images/amenity-layouts/T5_facilities.webp',
    amenities: [
      {
        id: '1',
        name: 'technogym_room',
        img: '/assets/images/amenity-layouts/images/Technogym.webp',
        coordinates: { x: 40, y: 36.98 },
      },
      {
        id: '2',
        name: 'boxing_room',
        img: '/assets/images/amenity-layouts/images/Boxing.jpg',
        coordinates: { x: 45, y: 36.98 },
      },
      {
        id: '3',
        name: 'yoga_room',
        img: '/assets/images/amenity-layouts/images/Yoga.webp',
        coordinates: { x: 20, y: 55 },
      },
      {
        id: '4',
        name: 'dance_room',
        coordinates: { x: 20, y: 48 },
      },
      {
        id: '5',
        name: 'pilates_room',
        img: '/assets/images/amenity-layouts/images/Pilates.webp',
        coordinates: { x: 30, y: 40 },
      },
      {
        id: '6',
        name: 'sauna_room',
        img: '/assets/images/amenity-layouts/images/Sauna.webp',
        coordinates: { x: 30, y: 50 },
      },
      {
        id: '7',
        name: 'locker_area',
        img: '/assets/images/amenity-layouts/images/Locker.jpg',
        coordinates: { x: 33, y: 52 },
      },
      {
        id: '8',
        name: 'restroom_area',
        img: '/assets/images/amenity-layouts/images/Khuvesinh.jpg',
        coordinates: { x: 33, y: 57 },
      },
      {
        id: '9',
        name: 'kid_wonder',
        img: '/assets/images/amenity-layouts/images/KidWonder.webp',
        coordinates: { x: 70, y: 22 },
      },
      {
        id: '10',
        name: 'ball_room',
        img: '/assets/images/amenity-layouts/images/Phongtiec.webp',
        coordinates: { x: 83, y: 22 },
      },
      {
        id: '11',
        name: 'karaoke_room',
        img: '/assets/images/amenity-layouts/images/Karaoke.jpg',
        coordinates: { x: 83, y: 35 },
      },
      {
        id: '12',
        name: 'golf_simulator_room',
        img: '/assets/images/amenity-layouts/images/Golf.jpg',
        coordinates: { x: 83, y: 45 },
      },
      {
        id: '13',
        name: 'co-working_space',
        img: '/assets/images/amenity-layouts/images/Coworking.jpg',
        coordinates: { x: 84, y: 55 },
      },
      {
        id: '14',
        name: 'livestream_room',
        img: '/assets/images/amenity-layouts/images/Livestream.jpg',
        coordinates: { x: 80, y: 52 },
      },
      {
        id: '15',
        name: 'community_room',
        coordinates: { x: 53, y: 53 },
      },
      {
        id: '16',
        name: 'zen_garden',
        img: '/assets/images/amenity-layouts/images/VuonthienZen.jpg',
        coordinates: { x: 20, y: 40 },
      },
      {
        id: '17',
        name: 'multi_purpose_kid_playground',
        coordinates: { x: 60, y: 27 },
      },
      {
        id: '18',
        name: 'sightseeing_garden',
        coordinates: { x: 48, y: 30 },
      },
    ],
  },
  top: {
    id: 'top',
    title: 'Tiện ích tầng thượng',
    tab: 'top_floor',
    img: '/assets/images/amenity-layouts/Top_facilities.webp',
    amenities: [
      {
        id: '1',
        name: 'infinity_pool',
        img: '/assets/images/amenity-layouts/images/Top-Hoboivocuc.jpg',
        coordinates: { x: 40, y: 39 },
      },
      {
        id: '2',
        name: 'jacuzzi_pool',
        img: '/assets/images/amenity-layouts/images/Top-Hoboi.jpg',
        coordinates: { x: 33, y: 50 },
      },
      {
        id: '3',
        name: 'healing_water_bed',
        img: '/assets/images/amenity-layouts/images/Top-Hoboi.jpg',
        coordinates: { x: 33, y: 53 },
      },
      {
        id: '4',
        name: 'kid_pool',
        img: '/assets/images/amenity-layouts/images/Top-Hoboitreem.jpg',
        coordinates: { x: 28, y: 51 },
      },
      {
        id: '5',
        name: 'waterfall_wall',
        img: '/assets/images/amenity-layouts/images/Top-Thacnuoc.jpg',
        coordinates: { x: 29, y: 54 },
      },
      {
        id: '6',
        name: 'sunbath_area',
        img: '/assets/images/amenity-layouts/images/Top-Khutamnang.jpg',
        coordinates: { x: 53, y: 48 },
      },
      {
        id: '7',
        name: 'change_room',
        coordinates: { x: 61, y: 45.5 },
      },
      {
        id: '8',
        name: 'rooftop_lounge',
        img: '/assets/images/amenity-layouts/images/Top-Skylounge.webp',
        coordinates: { x: 27, y: 40 },
      },
      {
        id: '9',
        name: 'bbq_area',
        img: '/assets/images/amenity-layouts/images/Top-BBQ.webp',
        coordinates: { x: 80, y: 55 },
      },
      {
        id: '10',
        name: 'water_stairs',
        coordinates: { x: 53, y: 40 },
      },
      {
        id: '11',
        name: 'star_gazing_garden',
        img: '/assets/images/amenity-layouts/images/Top-Vuongngamsao.jpg',
        coordinates: { x: 38, y: 50 },
      },
      {
        id: '12',
        name: 'theater_area',
        img: '/assets/images/amenity-layouts/images/Top-Khuchieuphim.webp',
        coordinates: { x: 50, y: 55 },
      },
      {
        id: '13',
        name: 'glass_floor_pool',
        img: '/assets/images/amenity-layouts/images/Top-Hoboisankinh.jpg',
        coordinates: { x: 33, y: 46 },
      },
      {
        id: '14',
        name: 'checkin_point',
        coordinates: { x: 24, y: 48 },
      },
      {
        id: '15',
        name: 'healing_oasis',
        img: '/assets/images/amenity-layouts/images/Top-Ocdaothugian.jpg',
        coordinates: { x: 20, y: 53 },
      },
    ],
  },
};
